<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import { ref } from 'vue';

import { FutureDeliveryDates } from '@/api/shippingCalculator';
import TextButton from '@/components/base/TextButton.vue';
import DeliveryDateCalendar from '@/components/checkout/steps/delivery/DeliveryDateCalendar.vue';
import { DateString } from '@/utils/dateTime';

const emit = defineEmits(['get-future-delivery', 'selected-delivery-date', 'update:modelValue']);

const props = defineProps<{
  futureDeliveryDates?: FutureDeliveryDates;
  loadingShippingOffers: boolean;
  modelValue?: DateString;
}>();

const selectedDeliveryDate = useVModel(props, 'modelValue', emit);

const showCalendar = ref(false);
const handleDeliveryToggle = () => {
  if (selectedDeliveryDate.value) {
    selectedDeliveryDate.value = undefined;
  } else {
    if (!props.futureDeliveryDates) emit('get-future-delivery');
    showCalendar.value = true;
  }
};
const closeIcon = nutshell['img/close.svg'];
</script>

<template>
  <div>
    <div class="flex items-center">
      <img
        v-if="selectedDeliveryDate"
        class="p-2 pl-0 m-0 text-base cursor-pointer h-7 leading-0"
        alt="Close icon"
        :src="closeIcon"
        tabindex="0"
        aria-label="close modal"
        data-test="close-icon"
        @click="handleDeliveryToggle()"
      />
      <TextButton
        @click="handleDeliveryToggle()"
        data-test="delivery-date-change"
        @keydown.enter.prevent="handleDeliveryToggle()"
        @keydown.space.prevent="handleDeliveryToggle()"
      >
        {{
          selectedDeliveryDate
            ? 'Reset your chosen delivery date'
            : 'Deliver your order at a later date'
        }}
      </TextButton>
    </div>
    <DeliveryDateCalendar
      v-model="selectedDeliveryDate"
      :isOpen="showCalendar"
      :futureDeliveryDates="futureDeliveryDates"
      @close-calendar="showCalendar = false"
      :loadingShippingOffers="loadingShippingOffers"
    />
  </div>
</template>
